import {DatosEnvioRetiro} from "../modelo/EnvioRetiroDefinitivo";

export const ENVIAR_SAT_RETIRO = "ENVIAR_SAT_RETIRO";
export const ENVIAR_SAT_MASIVO_RETIRO= "ENVIAR_SAT_MASIVO_RETIRO";
export const ERROR_AUTORIZACION = "ERROR_AUTORIZACION";
export const ERROR_ENVIO_RETIRO_INDIVIDUAL = "ERROR_ENVIO_RETIRO_INDIVIDUAL";
export const ERROR_ENVIO_RETIRO_MASIVO = "ERROR_ENVIO_RETIRO_MASIVO";
export const ENVIO_EXITOSO_RETIRO = "ENVIO_EXITOSO_RETIRO";
export const ENVIO_EXITOSO_RETIRO_MASIVO = "ENVIO_EXITOSO_RETIRO_MASIVO";
export const DESCARGAR_PLANTILLA_MASIVO_RETIRO = "DESCARGAR_PLANTILLA_MASIVO_RETIRO";
export const PLANTILLA_RETIRO_OBTENIDA = "PLANTILLA_RETIRO_OBTENIDA";
export const ERROR_OBTENIENDO_PLANTILLA_RETIRO = "ERROR_OBTENIENDO_PLANTILLA_RETIRO";
export const LIMPIAR_MENSAJES_RETIRO = "LIMPIAR_MENSAJES_RETIRO";

export const enviarSATRetiroIndividual = (datosEnvioRetiro: DatosEnvioRetiro) => ({ type: ENVIAR_SAT_RETIRO, datosEnvioRetiro });
export const enviarSATRetiroMasivo = (archivoEnvioRetiro: File) => ({ type: ENVIAR_SAT_MASIVO_RETIRO, archivoEnvioRetiro});
export const errorAutorizacion = () => ({ type: ERROR_AUTORIZACION});
export const errorEnvioRetiroIndividual = (mensajeRespuesta: string) => ({ type: ERROR_ENVIO_RETIRO_INDIVIDUAL, mensajeRespuesta});
export const errorEnvioRetiroMasivo = (mensajeRespuesta: string) => ({ type: ERROR_ENVIO_RETIRO_MASIVO, mensajeRespuesta});
export const envioRetiroExito = (poliza: string, dni: string) => ({ type: ENVIO_EXITOSO_RETIRO, poliza, dni});
export const envioRetiroMasivoExito = () => ({ type: ENVIO_EXITOSO_RETIRO_MASIVO});
export const descargarPlantillaMasivoRetiro = () => ({ type: DESCARGAR_PLANTILLA_MASIVO_RETIRO});
export const plantillaRetiroObtenida = () => ({type: PLANTILLA_RETIRO_OBTENIDA});
export const errorObteniendoPlantillaRetiro = () => ({type: ERROR_OBTENIENDO_PLANTILLA_RETIRO});
export const limpiarMensajesRetiro = () => ({type: LIMPIAR_MENSAJES_RETIRO});









// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/procesar_retiro/modulos/procesarRetiroActions.ts